import React from 'react'
import { cn } from '@/lib/utils'

interface TextShimmerProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Render as a block element instead of inline. */
  as?: 'span' | 'p' | 'div'
}

/**
 * Subtle animated shimmer over text — used for loading states where copy is
 * shown but data isn't ready yet (e.g. "Loading…"). Dual-mode + respects
 * prefers-reduced-motion (see `.text-shimmer` in index.css).
 */
export const TextShimmer: React.FC<TextShimmerProps> = ({ as = 'span', className, children, ...props }) => {
  const Tag = as as any
  return (
    <Tag className={cn('text-shimmer', className)} {...props}>
      {children}
    </Tag>
  )
}

export default TextShimmer
